export default __webpack_public_path__ + "static/char-s-56-en-48624143d05a0734f28cdda4c68b46ad.webp";